/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/loket/${payload.id}/loket-items?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async candidate({}, payload) {
    const url = `/lokasi/${payload.id}/items/candidate?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/loket/${payload.id}/loket-items`;
    return http.post(url, payload.params);
  },

  async detail({}, payload) {
    const url = `/loket/${payload.loketId}/loket-items/${payload.id}`;
    return await http.get(url).then(({ data }) => data);
  },

  update({}, payload) {
    const url = `/loket/${payload.loketId}/loket-items/${payload.id}`;
    return http.patch(url, payload.params);
  },

  delete({}, payload) {
    const url = `/loket/${payload.loketId}/loket-items/${payload.id}`;
    return http.delete(url);
  },

  status({}, payload) {
    const url = `/loket/${payload.loketId}/loket-items/${payload.id}/${payload.status}`;
    return http.post(url);
  },
};
